import { useState } from 'react';
import css from './CourseAbsence.module.css';

function CourseAbsence({ courseDetails }) {
    let [absence, setAbsence] = useState([{ data: [] }]);

    let days = 10;
    let data = [];
    for (let i = 0; i < days; i++) {
        data.push({ day: i + 1 });
    }

    courseDetails = courseDetails.slice();

    if (absence.length !== courseDetails.length) {
        let template = [];

        if (template.length === 0) {
            courseDetails.forEach((st) => {
                template.push({
                    student: st.studentName,
                    studentNo: st.studentNo,
                    data: [],
                });
            });
            data.forEach((x) => {
                template.map((a) =>
                    a.data.push({
                        day: x.day,
                        abs: 0,
                    })
                );
            });
        }
        setAbsence((state) => template.slice());
    }

    const absChange = (e, studentNo, day) => {
        let studentIndex;
        let dayIndex;
        absence.forEach((a, stInd) => {
            if (a.studentNo === studentNo) {
                studentIndex = stInd;
                a.data.forEach((data, dataInd) => {
                    if (data.day === Number(day)) {
                        dayIndex = dataInd;
                    }
                });
            }
        });
        setAbsence((state) => {
            state[studentIndex].data[dayIndex].abs = Number(e.target.value);

            return state.slice();
        });
    };

    const currentDay = 4;

    return (
        <div>
            <h3>Absence</h3>
            <table>
                <th>Name</th>
                {data.map((d) => (
                    <th>Day {d.day}</th>
                ))}
                <th>Total</th>
                {absence.map((a, i) => (
                    <tr key={a.studentNo}>
                        <td>
                            ({a.studentNo}) {a.student}
                        </td>
                        {a.data.map((x, k) => (
                            <td key={x.day}>
                                <input
                                    type="number"
                                    className={
                                        x.abs > 0 && x.abs < 6 ? `${css.orange}` : Number(x.abs) === 6 ? `${css.red}` : x.day <= currentDay ? `${css.input}` : `${css.white}`
                                    }
                                    value={x.abs}
                                    disabled={x.day === currentDay ? false : true}
                                    onChange={(e) => absChange(e, a.studentNo, x.day)}
                                    min={0}
                                    max={6}
                                ></input>
                            </td>
                        ))}
                        <td className={css.total}>{a.data.reduce((s, z) => s + Number(z.abs), 0)}</td>
                    </tr>
                ))}
            </table>
        </div>
    );
}

export default CourseAbsence;
